<!-- app-content-header start -->
@if (contentHeader) {
  <div class="content-header row">
    <div class="content-header-left col-md-9 col-12 mb-2">
      @if (!isFullscreen) {
        <div class="row breadcrumbs-top">
          <div class="col-12 d-flex">
            <h2
              class="content-header-title float-start mb-0"
              [translate]="contentHeader.translate">
              {{ contentHeader.headerTitle }}
            </h2>
            <!-- app-breadcrumb component -->
            <app-breadcrumb [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
          </div>
        </div>
      }
    </div>
    @if (contentHeader.actionButton) {
      <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
        <div class="mb-3 breadcrum-right">
          <button
            class="btn-icon btn btn-round btn-sm"
            type="button"
            (click)="toggleFullscreen()"
            rippleEffect>
            @if (!isFullscreen) {
              <span
                ><i
                  data-feather="maximize"
                  class="text-primary"></i
              ></span>
            }
            @if (isFullscreen) {
              <span
                ><i
                  data-feather="minimize"
                  class="text-primary"></i
              ></span>
            }
          </button>
        </div>
      </div>
    }
  </div>
}
<!-- app-content-header end -->
